"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const HomeIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 22a1 1 0 001-1V9.412a1 1 0 00-.344-.754l-7-6.087a1 1 0 00-1.312 0l-7 6.087A1 1 0 004 9.412V21a1 1 0 001 1h4a1 1 0 001-1v-6h4v6a1 1 0 001 1h4zM18 9.868L12 4.65 6 9.868V20h2v-6a1 1 0 011-1h6a1 1 0 011 1v6h2V9.868z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.HomeIcon = HomeIcon;
//# sourceMappingURL=home_icon.js.map